// tslint:disable max-line-length
export const SliderHandleSvg: string =
`<svg xmlns="http://www.w3.org/2000/svg" class="$state$" width="20" height="20">
  <style>
    circle{fill:#fff;stroke-width:1;stroke:#666}
    .focus circle{stroke:#3498db}
    .active circle{stroke:#333}
    .disabled circle{fill:#ebebeb;stroke:#b4b4b4}
  </style>
  <circle cx="10" cy="10" r="7.5"/>
</svg>`;
